import { FC, isValidElement, Children, ReactNode, Fragment, ReactElement } from "react";

// eslint-disable-next-line @typescript-eslint/ban-types
export function isElementComponentOfType<T>(element: {} | null | undefined, type: FC<T>): boolean {
	if (!isValidElement(element)) return false;

	//if the component is being proxied the type wont match, but the displayName will
	return element.type === type || (element.type as FC).displayName === type.name;
}

export function isOnlyChildOfType<T>(children: ReactNode | ReactNode[], type: FC<T>): boolean {
	const childArray = Children.toArray(children);
	return childArray.length === 1 && isElementComponentOfType(childArray[0], type);
}

export function isReactFragment(node: unknown): node is ReactElement<{ children: ReactNode }> {
	return (node as ReactElement).type === Fragment;
}

export function allChildrenAreOfType<T>(children: ReactNode | ReactNode[], type: FC<T>): boolean {
	const childArray = Children.toArray(children);
	return childArray.every((c) => {
		if (isReactFragment(c)) {
			return allChildrenAreOfType(c.props.children, type);
		} else {
			return isElementComponentOfType(c, type);
		}
	});
}
